/* eslint-disable */
export const LangOrders = {
	"legend-abbr": [
		{
			"name": "ČOV",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "ČSSZ, OSSZ",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "DDM",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "DPS",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "FÚ",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "FVE",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "gar.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "gymn.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "CHKO",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "CHA",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "KHS",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "knih.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "kot.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "LDN",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "MŠ",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "MÚ",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "MVE",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "NCH",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "NPP",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "NPR",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "NP",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "NS",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "OÚ",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "PP",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "PR",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "rozhl.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "SOŠ",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "SOU",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "SPŠ",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "SŠ",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "syn.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "ÚP",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "vých. lyž. stop.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "vdj.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "vdp.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "vod.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "vod. n., v. n.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "VOŠ",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "vyhl.",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "zahr., zahr. osada:",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "ZD",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "ZŠ",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		},
		{
			"name": "ZUŠ",
			"set": [
				"turistnew",
				"winter",
				"geographical"
			]
		}
	],
	"legend-geographical": "dalnice|rychlost_silnice|mezinar_silnice|silnice_1_tr|silnice_2_tr|silnice_3_tr|ulice_plochy|jednosmer_zakaz|obousmerka|zakaz_motor_voz|zpevnenky_lesni_polni|pesina_horska_pesina|prusek_povalovy_chodnik|viceproud_usek|semafor_kruhac|tunel|dalnice_stavba_plan|silnice_stavba_plan|podchod_schody|zeleznice|zeleznicni_tunel|stanice_zast|zel_vlecka|zel_zrusena|zeleznice_stavba|tramvaj|lanovka_kabinka|lanovka_sedacka|lanovka_naklad|lyz_vlek|draha_boby_sane|zipline|zed|plot_obora|el_vedeni|zem_souradnice|zahr_zastavba|prumysl_lom|hrbitov_hriste|rezervace|NP_CHKO|prir_park|alej|voj_prostor|hranice_statu|reka_potok|vod_plocha_bazina|tok_obcasny|vodni_vlek|vrchol_udoli|vrstevnice|skaly_kamenpole|lomova_stena|skaly_vrty_kasny|bunkr|socha_kriz|autobusove_stani_cislo|gate_cislo",
	"legend-haptic": "railway|motorway|class1road|stateborder|seat|townname|motorwaynumber|builtuparea|waterarea|watercourse|road|towndistrict|buildings|water|greenarea|industrialarea|streetpath|tram|busstop|stairs|cableway|wall|brook|church|parking|railwaystation",
	"legend-history": "history01|history02|history03|history04|history05|history06|history07|history08|history09|history10|history11|history12|history13|history14|history15|history16|history17|history18|history19|history20|history21|history22|history23|history24|history25|history26|history27|history28|history29|history30|history31|history32|history33|history34|history35|history36|history37",
	"legend-krkonose": "krkonose01|krkonose02|krkonose03|krkonose04|krkonose05|krkonose06|krkonose07|krkonose08|krkonose09|krkonose10|krkonose11|krkonose12|krkonose13|krkonose14|krkonose15|krkonose16|krkonose17|krkonose18|krkonose19|krkonose20|krkonose21|krkonose22|krkonose23|krkonose24|krkonose25|krkonose26|krkonose27|krkonose28|krkonose29|krkonose30|krkonose31",
	"legend-mobil": "dalnice|cs|sk|en|de|fr|es|pl|ru|silnice_motor_vozidla|cs|sk|en|de|fr|es|pl|ru|mezinar_silnice|cs|sk|en|de|fr|es|pl|ru|silnice_1_tr|cs|sk|en|de|fr|es|pl|ru|silnice_2_tr|cs|sk|en|de|fr|es|pl|ru|silnice_3_tr_hlavni|cs|sk|en|de|fr|es|pl|ru|ulice_plochy|cs|sk|en|de|fr|es|pl|ru|jednosmer_zakaz|cs|sk|en|de|fr|es|pl|ru|zakaz_motor_vozidel|cs|sk|en|de|fr|es|pl|ru|zpevnenky_lesni_polni|cs|sk|en|de|fr|es|pl|ru|pesina_prusek|cs|sk|en|de|fr|es|pl|ru|viceproude_useky|cs|sk|en|de|fr|es|pl|ru|semafor_kruhac|cs|sk|en|de|fr|es|pl|ru|tunel_exit|cs|sk|en|de|fr|es|pl|ru|dalnice_stavba_plan|cs|sk|en|de|fr|es|pl|ru|silnice_stavba_plan|cs|sk|en|de|fr|es|pl|ru|podchod_schody|cs|sk|en|de|fr|es|pl|ru|zeleznice|cs|sk|en|de|fr|es|pl|ru|zeleznicni_tunel|cs|sk|en|de|fr|es|pl|ru|stanice_zast|cs|sk|en|de|fr|es|pl|ru|zel_vlecka_zrusena|cs|sk|en|de|fr|es|pl|ru|tramvaj|cs|sk|en|de|fr|es|pl|ru|lanovka_kabinka|cs|sk|en|de|fr|es|pl|ru|lanovka_sedacka|cs|sk|en|de|fr|es|pl|ru|lanovka_naklad|cs|sk|en|de|fr|es|pl|ru|lyz_vlek|cs|sk|en|de|fr|es|pl|ru|draha_boby_sane|cs|sk|en|de|fr|es|pl|ru|zed|cs|sk|en|de|fr|es|pl|ru|plot_obora|cs|sk|en|de|fr|es|pl|ru|el_vedeni|cs|sk|en|de|fr|es|pl|ru|les_klec|cs|sk|en|de|fr|es|pl|ru|chmel_vino_sad|cs|sk|en|de|fr|es|pl|ru|golf_zahr_zastavba|cs|sk|en|de|fr|es|pl|ru|prumysl_lom|cs|sk|en|de|fr|es|pl|ru|hrbitov_hriste|cs|sk|en|de|fr|es|pl|ru|rezervace|cs|sk|en|de|fr|es|pl|ru|NP_CHKO|cs|sk|en|de|fr|es|pl|ru|prir_park|cs|sk|en|de|fr|es|pl|ru|alej|cs|sk|en|de|fr|es|pl|ru|voj_prostor|cs|sk|en|de|fr|es|pl|ru|hranice_statu|cs|sk|en|de|fr|es|pl|ru|reka_potok|cs|sk|en|de|fr|es|pl|ru|voda_plocha_bazina|cs|sk|en|de|fr|es|pl|ru|tok_obcasny|cs|sk|en|de|fr|es|pl|ru|tur_znacky_rozc|cs|sk|en|de|fr|es|pl|ru|mistni_znacky|cs|sk|en|de|fr|es|pl|ru|naucne_stezky|cs|sk|en|de|fr|es|pl|ru|cyklo_nazev|cs|sk|en|de|fr|es|pl|ru|cyklo_barevna|cs|sk|en|de|fr|es|pl|ru|cyklostezka|cs|sk|en|de|fr|es|pl|ru|vozickar_stezka|cs|sk|en|de|fr|es|pl|ru|ferrata|cs|sk|en|de|fr|es|pl|ru|vrchol_udoli|cs|sk|en|de|fr|es|pl|ru|skaly_kamenpole|cs|sk|en|de|fr|es|pl|ru|skaly_vrty_kasny|cs|sk|en|de|fr|es|pl|ru|vysilac_vez|cs|sk|en|de|fr|es|pl|ru|bunkr_vetrnik|cs|sk|en|de|fr|es|pl|ru|kostel_socha_kriz|cs|sk|en|de|fr|es|pl|ru|autobusove_stani_cislo|cs|sk|en|de|fr|es|pl|ru",
	"legend-mobil-winter": "lyz_magistrala|cs|sk|en|de|fr|es|pl|ru|lyz_trasa_hlavni|cs|sk|en|de|fr|es|pl|ru|lyz_trasa_tur_tyce|cs|sk|en|de|fr|es|pl|ru|trat_zavod_rozc|cs|sk|en|de|fr|es|pl|ru|sankarska_trasa|cs|sk|en|de|fr|es|pl|ru|sjezdovka_cerna|cs|sk|en|de|fr|es|pl|ru|sjezdovka_cervena|cs|sk|en|de|fr|es|pl|ru|sjezdovka_modra|cs|sk|en|de|fr|es|pl|ru|sjezdovka_snowpark|cs|sk|en|de|fr|es|pl|ru|sjezdovka_freeride|cs|sk|en|de|fr|es|pl|ru|sjezd_osvetleni|cs|sk|en|de|fr|es|pl|ru|lanovka_kabinka|cs|sk|en|de|fr|es|pl|ru|lanovka_sedacka|cs|sk|en|de|fr|es|pl|ru|lyz_vlek|cs|sk|en|de|fr|es|pl|ru|draha_boby_sane|cs|sk|en|de|fr|es|pl|ru|lanovka_naklad|cs|sk|en|de|fr|es|pl|ru|lavinovy_svah|cs|sk|en|de|fr|es|pl|ru|dalnice|cs|sk|en|de|fr|es|pl|ru|silnice_motor_vozidla|cs|sk|en|de|fr|es|pl|ru|mezinar_silnice|cs|sk|en|de|fr|es|pl|ru|silnice_1_tr|cs|sk|en|de|fr|es|pl|ru|silnice_2_tr|cs|sk|en|de|fr|es|pl|ru|silnice_3_tr_hlavni|cs|sk|en|de|fr|es|pl|ru|ulice_plochy|cs|sk|en|de|fr|es|pl|ru|jednosmer_zakaz|cs|sk|en|de|fr|es|pl|ru|zakaz_motor_vozidel|cs|sk|en|de|fr|es|pl|ru|zpevnenky_lesni_polni|cs|sk|en|de|fr|es|pl|ru|pesina_prusek|cs|sk|en|de|fr|es|pl|ru|viceproude_useky|cs|sk|en|de|fr|es|pl|ru|semafor_kruhac|cs|sk|en|de|fr|es|pl|ru|tunel_exit|cs|sk|en|de|fr|es|pl|ru|dalnice_stavba_plan|cs|sk|en|de|fr|es|pl|ru|silnice_stavba_plan|cs|sk|en|de|fr|es|pl|ru|podchod_schody|cs|sk|en|de|fr|es|pl|ru|zeleznice|cs|sk|en|de|fr|es|pl|ru|zeleznicni_tunel|cs|sk|en|de|fr|es|pl|ru|stanice_zast|cs|sk|en|de|fr|es|pl|ru|zel_vlecka_zrusena|cs|sk|en|de|fr|es|pl|ru|tramvaj|cs|sk|en|de|fr|es|pl|ru|zed|cs|sk|en|de|fr|es|pl|ru|plot_obora|cs|sk|en|de|fr|es|pl|ru|el_vedeni|cs|sk|en|de|fr|es|pl|ru|les_klec|cs|sk|en|de|fr|es|pl|ru|zahr_zastavba|cs|sk|en|de|fr|es|pl|ru|prumysl_lom|cs|sk|en|de|fr|es|pl|ru|hrbitov_hriste|cs|sk|en|de|fr|es|pl|ru|alej|cs|sk|en|de|fr|es|pl|ru|voj_prostor|cs|sk|en|de|fr|es|pl|ru|hranice_statu|cs|sk|en|de|fr|es|pl|ru|reka_potok|cs|sk|en|de|fr|es|pl|ru|voda_plocha_bazina|cs|sk|en|de|fr|es|pl|ru|tok_obcasny|cs|sk|en|de|fr|es|pl|ru|vrchol_udoli|cs|sk|en|de|fr|es|pl|ru|skaly_kamenpole|cs|sk|en|de|fr|es|pl|ru|skaly_vrty_kasny|cs|sk|en|de|fr|es|pl|ru|vysilac_vez|cs|sk|en|de|fr|es|pl|ru|bunkr_vetrnik|cs|sk|en|de|fr|es|pl|ru|kostel_socha_kriz|cs|sk|en|de|fr|es|pl|ru|autobusove_stani_cislo|cs|sk|en|de|fr|es|pl|ru",
	"legend-traffic": "hustota_dopravy_mirna|hustota_dopravy_stredni|hustota_dopravy_vysoka|hustota_dopravy_kolona",
	"legend-turistnew": "hustota_dopravy_natrase_mirna|hustota_dopravy_natrase_stredni|hustota_dopravy_natrase_vysoka|hustota_dopravy_natrase_kolona|dalnice|silnice_motor_vozidla|mezinar_silnice|silnice_1_tr|silnice_2_tr|silnice_3_tr_hlavni|ulice_plochy|jednosmer_zakaz|obousmerka|zakaz_motor_vozidel|ulice_plochy_uzavrene|zpevnenky_lesni_polni|pesina_horska_pesina|prusek_povalovy_chodnik|tunel_podchod|semafor_kruhac|exit|silnice_stavba_plan|pasaz_schody|zeleznice|zeleznicni_tunel|stanice_zast|zel_vlecka|zel_zrusena|zeleznice_stavba|tramvaj|lanovka_kabinka|lanovka_sedacka|lanovka_naklad|lyz_vlek|draha_boby_sane|zipline|zed|plot_obora|el_vedeni|les_klec|vino_chmel_sad|golf_zahr_zastavba|prumysl_lom|hrbitov_hriste|rezervace|NP_CHKO|prir_park|opvz|alej|voj_prostor|hranice_statu|reka_potok|most_lavka|voda_plocha_bazina|priliv_utes|voda_obcasna|tok_obcasny|vodni_vlek|tur_znacky_rozc|mistni_znacky|naucne_stezky|tur_znacky_tvary|svatojakubska_cesta|tur_znacky_obtiznost|ferrata|zajisteny_usek_tur_trasy|cyklo_nazev|cyklo_barevna|cyklostezka|cyklo_singletrack|vozickar_stezka|vrchol_udoli|vrstevnice|skaly_kamenpole|lomova_stena|bare_rock|skaly_vrty_kasny|bunkr|socha_kriz|autobusove_stani_cislo|gate_cislo",
	"legend-winter": "lyz_magistrala|lyz_trasa_hlavni|lyz_trasa_tur_tyce|lyz_trasa_obtiznost|stari_stopy1|stari_stopy3|stari_stopy7|stari_stopy_null|skitour|sankarska_trasa|zimni_pesi_trasa|zimni_pesi_trasa_sneznice|sjezdovka_cerna|sjezdovka_cervena|sjezdovka_modra|sjezdovka_snowpark|sjezdovka_freeride|sjezd_osvetleni|nadm_vyska|lavinovy_svah|lanovka_kabinka|lanovka_sedacka|lanovka_naklad|lyz_vlek|draha_boby_sane|zipline|hustota_dopravy_natrase_mirna|hustota_dopravy_natrase_stredni|hustota_dopravy_natrase_vysoka|hustota_dopravy_natrase_kolona|dalnice|silnice_motor_vozidla|mezinar_silnice|silnice_1_tr|silnice_2_tr|silnice_3_tr_hlavni|ulice_plochy|jednosmer_zakaz|obousmerka|zakaz_motor_vozidel|ulice_plochy_uzavrene|zpevnenky_lesni_polni|pesina_horska_pesina|prusek_povalovy_chodnik|tunel_podchod|silnice_zimni|semafor_kruhac|exit|silnice_stavba_plan|pasaz_schody|zeleznice|zeleznicni_tunel|stanice_zast|zel_vlecka|zel_zrusena|zeleznice_stavba|tramvaj|zed|plot_obora|el_vedeni|les|zahr_zastavba|prumysl_lom|hrbitov_hriste|alej|rezervace_winter|opvz|voj_prostor|hranice_statu|reka_potok|most_lavka|voda_plocha_bazina|priliv_utes|voda_obcasna|vodni_vlek|vrchol_udoli|vrstevnice|skaly_kamenpole|lomova_stena|bare_rock|skaly_vrty_kasny|bunkr|socha_kriz|autobusove_stani_cislo|gate_cislo"
};
